import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import {
  CategorySelectedApplicationEvent, NavigationApplicationEvent,
  SeeAllPromotionsApplicationEvent,
  TopNavbarCategoryMenuOpenApplicationEvent
} from '~shared/modules/application-event/models';
import {
  ApplicationCategorySelectedEventType,
  ApplicationNavigationEventType
} from '~shared/modules/application-event/constants';
import { interval, Subject, Subscription } from 'rxjs';
import { repeat, take, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';


const minSecondsBeforeFiringPromotionsEvent = 3;
const oneSecond = 1000;
const roundsCountToExecuteWaitingScript = 4;

export class CategoriesNavbarApplicationEventHandler {

  private promoMenuTimer$: Subscription;
  private destroySubject$ = new Subject();

  constructor(private applicationEventService: ApplicationEventService, private translate: TranslateService) {
    this.promoMenuTimer$ = new Subscription();
  }

  public onMenuClosed() {
    if (this.promoMenuTimer$) {
      this.promoMenuTimer$.unsubscribe();
    }
  }

  public publishPromotionCategorySelected(name: string): void {
    this.applicationEventService.publish(
      new CategorySelectedApplicationEvent(
        ApplicationCategorySelectedEventType.TopAngebote,
        name,
        {
          leaf_category: name,
          root_category: ``
        }
      )
    );
  }

  public publishSeeAllPromotion(): void {
    this.applicationEventService.publish(
      new SeeAllPromotionsApplicationEvent(true)
    );
  }

  public publishPromotionsMenuOpen(): void {
    this.promoMenuTimer$ = interval(oneSecond)
      .pipe(
        take(roundsCountToExecuteWaitingScript),
        repeat()
      )
      .subscribe(seconds => {
        if (seconds === minSecondsBeforeFiringPromotionsEvent) {
          this.publishTopNavbarCategoryMenuOpen();
        }
      });
  }

  public publishAppNavigation(elementTitle: string, label?: string): void {
    if (label) {
      this.translate
        .get(label)
        .pipe(takeUntil(this.destroySubject$))
        .subscribe(value => {
          this.publishNavigation(`${elementTitle}/${value} ${elementTitle}`);
        });
    } else {
      this.publishNavigation(elementTitle);
    }
  }

  public destroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  private publishNavigation(title: string): void {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.NavigationBarClick,
        title
      )
    );
  }

  private publishTopNavbarCategoryMenuOpen(): void {
    this.applicationEventService.publish(
      new TopNavbarCategoryMenuOpenApplicationEvent(true)
    );
  }
}
